<template>
    <div>
        <div class="d-flex align-items-center justify-content-center pt-3" style="background-color: #39A5BF">

            <!-- <div class="d-flex align-items-center text-start text-white"> -->
             <div class="container-fluid px-0 pt-3">
                  <div class="col-12 col-lg-8 offset-lg-2">
                    <img :src="`${$API_ASSETS}40e7688f-e6c5-444b-8a2f-8db0c435eb63?width=1200&quality=80`" class="img-fluid w-100" fetchpriority="high" />
                  </div>
             </div>
            <!-- </div> -->

        </div>
        <div class="container-fluid pt-2" style="background-color: #39A5BF">
            <div class="col-12 col-md-6 offset-md-3 text-white text-center">
                <div class="py-2 fs-5">
              It is the goal of Atlas Improv Company to bring the art of improv to as many people as we can in order to spread joy and build community within Madison, Wisconsin, and beyond. We believe that art and laughter can be a force for good in the world, and that anyone can participate in the art of improv and be a part of our community; all they need is empathy, vulnerability, and the ability to listen to, and be present with those they share the stage with, in order to follow and discover what is fun, together.
             </div>
                <div class="py-2 pb-5 fs-5 mt-3">
                  To that end, although Atlas Improv Company is not aligned with any political party or movement, in order to foster inclusion and diversity within our community and the community at large, we support and will advocate for the basic rights and recognition of all people regardless of their race, gender, gender identity, ethnicity, country of origin, religion, faith, age, or sexuality. Though some may see this as a political statement, we at Atlas do not believe that treating others with dignity, kindness, and respect is a political position, but a question of basic human decency.
                </div>
            </div>
        </div>

        <div class="bg-dark w-100 mb-5" style="height: 2px;"></div>

        <MembersSection />
        <div class="container-fluid position-relative pt-2 site-black-bg" ref="auditionsSection"
            style="margin: 0; padding-left:0;padding-right: 0; width: 100%; height: auto; object-fit: fill; overflow: hidden;">
            <!-- Desktop Version (Visible on extra-large screens and up) -->
            <div class="d-none d-xl-block position-relative">
                <img :src="`${$API_ASSETS}98b0081e-eab9-4b4a-a161-a61f9e16af9f?width=1600&quality=80`"
                    class="img-fluid w-100 auditions-img" :class="{ 'auditions-img-visible': auditionsVisible }" />

                <!-- Overlayed Text -->
                <div class="position-absolute w-100" style="top: 30%; left: 0; padding-left: 10%;">
                    <div class="col-lg-4 text-white text-start">
                        <div class="text-uppercase display-4 oswald-bold">Auditions</div>
                        <div class="py-2">
                            Think you've got a natural talent for performance? Are you quick on your feet and like to
                            make things up as you go? If so, you're in luck: Atlas Improv is holding open call
                            auditions!
                        </div>
                        <div v-if="audition" class="py-2">
                            Auditions will be held <strong>{{ audition?.day_1 }} and {{ audition?.day_2 }} from {{ audition?.time_range }}</strong> each day.
                            You need only attend one of the two sessions, no need to bring a headshot or resume. All we
                            ask is that you come dressed to move and prepared to play (close-toed shoes please). No
                            experience required, all are welcome to apply.
                        </div>
                        <a href="https://www.crowdwork.com/e/fall-company-auditions" target="_blank" rel="noopener"
                            class="btn light-btn text-uppercase mt-4" style="color: var(--site-black);">Register</a>
                    </div>
                </div>
            </div>

            <!-- Mobile/Tablet Version (Visible up to 1024px wide) -->
            <div class="d-block d-xl-none text-white text-start pt-5">
                <div class="text-uppercase h2 px-3 text-center pt-4 py-2">Auditions</div>
                <div class="py-2 px-5">
                    Think you've got a natural talent for performance? Are you quick on your feet and like to
                    make things up as you go? If so, you're in luck: Atlas Improv is holding open call auditions!
                </div>
                <div v-if="audition" class="py-2 px-5">
                    Auditions will be held <strong>{{ audition?.day_1 }} and {{ audition?.day_2 }} from {{ audition?.time_range }}</strong> each day.
                    You need only attend one of the two sessions, no need to bring a headshot or resume. All we
                    ask is that you come dressed to move and prepared to play (close-toed shoes please). No
                    experience required, all are welcome to apply.
                </div>
                <div class="px-5 pt-3 pb-3 text-center">
                    <a href="https://www.crowdwork.com/e/fall-company-auditions" target="_blank" rel="noopener"
                        class="btn light-btn text-uppercase" style="color: var(--site-black);">Register</a>
                </div>
                <img :src="require('@/assets/auditions-mobile.png')" class="img-fluid w-100 auditions-img" :class="{ 'auditions-img-visible': auditionsVisible }"
                    style="margin: 0; padding-right: 0; width: 100%; height: auto; object-fit: fill;" />
            </div>
        </div>

        <Footer />

    </div>



</template>

<script>

import axios from 'axios';
import { DateTime } from 'luxon';
import Footer from '../components/Footer.vue'
import MembersSection from '@/components/MembersSection.vue';


export default {
    name: 'Company',
    components: {
        Footer, MembersSection
    },
    data() {
      return {
        audition: null,
        auditionsVisible: false,
      };
    },
    mounted() {
      let initialized = false;
      setTimeout(() => { initialized = true; }, 200);
      this._auditionObserver = new IntersectionObserver((entries) => {
        if (initialized && entries[0].isIntersecting) {
          this.auditionsVisible = true;
          this._auditionObserver.disconnect();
        }
      }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
      this._auditionObserver.observe(this.$refs.auditionsSection);
    },
    beforeUnmount() {
      if (this._auditionObserver) this._auditionObserver.disconnect();
    },
    methods: {
      async fetchAuditionDates() {
        try {
          const response = await axios.post(this.$API_GRAPHQL, {
            query: `
              query {
                audition {
                  day_1
                  day_2
                }
              }
            `
          }, {
            headers: {
              Authorization: `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
              'Content-Type': 'application/json'
            }
          });
          const day1 = DateTime.fromISO(response.data.data.audition.day_1);
          const day2 = DateTime.fromISO(response.data.data.audition.day_2);

          this.audition = {
            day_1: day1.toFormat('cccc, LLLL d'),
            day_2: day2.toFormat('cccc, LLLL d'),
            time_range: `${day1.toFormat('h:mm a')}–${day1.plus({ hours: 2 }).toFormat('h:mm a')}`
          };
        } catch (error) {
          console.error('Error fetching audition dates:', error);
        }
      }
    },
    created() {
      this.fetchAuditionDates();
    },
};
</script>

<style scoped>
.auditions-img {
    transform: translateX(80px);
    opacity: 0;
    transition: transform 1.5s ease, opacity 1.5s ease;
}

.auditions-img.auditions-img-visible {
    transform: translateX(0);
    opacity: 1;
}
</style>
